import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { firestore, storage } from '../Firebase';
import { BeatLoader } from 'react-spinners';
import DropzoneVideo from './DropzoneVideo';
import { uploadImageToStorage } from '../utils/storageUpload';

const AddVideo = ({ toggleModal }) => {
  const [video, setVideo] = useState({
    title: '',
    isLive: '',
    vimeoType: '',
    vimeoID: '',
    vimeoKey: '',
    thumbnail: '',
  });
  const [imageName, setImageName] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [uploaded, setUploaded] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setVideo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onDropHandler = ({ name, uri }) => {
    setImageName(name);
    setImageSrc(uri);
    setVideo((prevState) => ({
      ...prevState,
      thumbnail: name,
    }));
    setUploaded(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log('Submitting video:', video);

    if (!uploaded) {
      toast.error('Please submit a thumbnail image.');
      return;
    }

    if (!video.title) {
      toast.error('Please enter a title.');
      return;
    }

    if (!video.vimeoType) {
      toast.error('Please enter a Vimeo Type.');
      return;
    }

    if (!video.vimeoID) {
      toast.error('Please enter Vimeo ID.');
      return;
    }

    if (!video.vimeoKey) {
      toast.error('Please enter a Vimeo Key.');
      return;
    }

    try {
      setLoading(true);

      const downloadURL = await handleFileUpload();

      await firestore.collection('videos').add({
        thumbnail: downloadURL,
        title: video.title,
        isLive: video.isLive,
        vimeoType: video.vimeoType,
        vimeoID: video.vimeoID,
        vimeoKey: video.vimeoKey,
      });

      setVideo({
        thumbnail: '',
        title: '',
        isLive: '',
        vimeoType: '',
        vimeoID: '',
        vimeoKey: '',
      });
      setImageName(null);
      setImageSrc(null);
      setUploaded(false);
      toggleModal(false);

      toast.success(video.title + ' added successfully.');
    } catch (error) {
      console.error('Error adding video:', error);
      toast.error(
        'An error occurred while adding the video. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  const handleFileUpload = async () => {
    if (imageName && imageSrc) {
      try {
        return await uploadImageToStorage(storage, imageSrc);
      } catch (error) {
        console.error('Error uploading file:', error);
        toast.error(
          'An error occurred while uploading the file. Please try again.'
        );
        throw error;
      }
    }
  };

  return (
    <>
      {loading && (
        <div className="overlay">
          <BeatLoader
            color="#36d7b7"
            size={15}
            loading={loading}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <DropzoneVideo onDropHandler={onDropHandler} imageName={imageName} />
        <div className="form-floating mb-3">
          <input
            type="text"
            className="form-control"
            name="title"
            placeholder="title"
            onChange={handleChange}
            value={video.title}
          />
          <label htmlFor="title">Title</label>
        </div>

        <fieldset className="mb-3">
          <legend className="form-label fs-6 mb-2">Vimeo Type</legend>
          <div className="d-flex gap-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="vimeoType"
                id="add-video-vimeo-event"
                value="event"
                onChange={handleChange}
                checked={video.vimeoType === 'event'}
              />
              <label className="form-check-label" htmlFor="add-video-vimeo-event">
                Event
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="vimeoType"
                id="add-video-vimeo-upload"
                value="upload"
                onChange={handleChange}
                checked={video.vimeoType === 'upload'}
              />
              <label className="form-check-label" htmlFor="add-video-vimeo-upload">
                Upload
              </label>
            </div>
          </div>
        </fieldset>

        <div className="form-floating mb-3">
          <input
            type="text"
            className="form-control"
            name="vimeoID"
            placeholder="vimeoID"
            onChange={handleChange}
            value={video.vimeoID}
          />
          <label htmlFor="vimeoID">Video ID</label>
        </div>
        <div className="form-floating mb-3">
          <input
            type="text"
            className="form-control"
            name="vimeoKey"
            placeholder="vimeoKey"
            onChange={handleChange}
            value={video.vimeoKey}
          />
          <label htmlFor="vimeoKey">Vimeo Key</label>
        </div>
        <div className="col-12 mb-5">
          <input type="submit" className="btn btn-primary mb-5" />
        </div>
      </form>
    </>
  );
};

export default AddVideo;
